import React, { useEffect } from 'react';
import styled from 'styled-components/macro';
import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';
import Div100vh from 'react-div-100vh';
import colors from '../../style/colors';
import fontSize from '../../style/fontSize';
import FixedHeaderAppBar from './FixedHeaderAppBar';
import { setSrcPath } from '../../libraries/ApplicationService';

const Container = styled(Div100vh)`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Card = styled.div`
  color: ${colors.greyDark};
  text-align: center;
  padding-left: 16px;
  padding-right: 16px;
`;
const Img = styled.img`
  width: 100px;
  margin: 0 auto;
  display: block;
`;
const Numbers = styled.div`
  font-size: 96px;
  color: ${colors.primary};
`;
const Message = styled.div`
  font-size: ${fontSize.xLarge};
  margin-top: 16px;
`;
const FinePrint = styled.div`
  font-size: ${fontSize.large};
  margin-top: 8px;
  margin-bottom: 36px;
`;
const StyledButton = styled(Button)`
  width: calc(100% - 8rem);
  color: ${colors.white} !important;
`;

export const HOME_BUTTON = '404-home-button';

const Page404 = props => {
  const { history, desktopLayout } = props;

  useEffect(() => {
    window.analyticsPage('page404', { platform: 'pwa' });
  }, []);

  const onBack = () => {
    history.goBack();
  };

  const onHome = () => {
    history.push('/');
  };

  return (
    <>
      <FixedHeaderAppBar
        showWallet
        isMobile={!desktopLayout}
        onBackClick={onBack}
      />
      <LinearProgress />
      <Container style={{ height: 'calc(100rvh - 68px)' }}>
        <Card>
          <Img src={setSrcPath('/black_logo.png')} />
          <Numbers>404</Numbers>
          <Message>Page not found</Message>
          <FinePrint>
            The page you are looking for does not exist, or an error has
            occured.
          </FinePrint>
          <StyledButton
            variant="contained"
            color="primary"
            onClick={onHome}
            data-testid={HOME_BUTTON}
          >
            Home
          </StyledButton>
        </Card>
      </Container>
    </>
  );
};

export default Page404;
